import {Controller} from "stimulus";

require("jquery-ui/ui/widgets/autocomplete");
require("jquery-ui/themes/base/core.css");
require('jquery-ui/themes/base/menu.css');
require('jquery-ui/themes/base/autocomplete.css');
require('jquery-ui/themes/base/theme.css');

export default class extends Controller {
        initialize() {
        this.streetsUrl = this.element.getAttribute("data-streets-url");
    }

    connect() {

        const delayTime = 600;
        const minSearchLength = 3;
        const _self = this;
        if (!$(this.element).hasClass('ui-autocomplete-input')) {

            $(this.element).autocomplete({
                source: function (request, response) {
                    if (document.querySelector(".cityId").value) {
                        $.getJSON(
                            _self.streetsUrl,
                            {
                                term: request.term,
                                cityId: document.querySelector(".cityId").value
                            },
                            response
                        );
                    } else {
                        response([]);
                    }
                },
                minLength: minSearchLength,
                delay: delayTime,
            });
        }
    }
}